import React, { useEffect, useRef, useState } from "react";
import { Material } from "../../../../../../data/entities";
import SearchBar from "../../../../../../shared/components/SearchBar";

interface OutsourceMaterialSearchBarProps {
    fetchItems: Function;
    menuList: Material[];
    selectedItems: Material[];
    handleOnclickItem: (item: Material, isAdded: boolean) => void;
    placeholder?: string;
}

const OutsourceMaterialSearchBar = ({
    fetchItems,
    menuList,
    selectedItems,
    handleOnclickItem,
    placeholder = "Tìm theo mã hoặc tên vật tư",
}: OutsourceMaterialSearchBarProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!containerRef.current?.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const isSelected = (material: Material) =>
        selectedItems.some((selectedMaterial) => selectedMaterial.id === material.id);

    return (
        <div ref={containerRef} style={{ position: "relative", width: "600px", maxWidth: "100%" }}>
            <SearchBar
                placeholder={placeholder}
                fetchItems={fetchItems}
                onFocus={() => setIsOpen(true)}
            />

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1600,
                        marginTop: 8,
                        backgroundColor: "#fff",
                        border: "1px solid #1677d2",
                        borderRadius: 4,
                        maxHeight: 300,
                        overflowY: "auto",
                    }}
                >
                    {menuList.map((material) => {
                        const standardCount = material.outsource_standards?.length || 0;
                        const canSelect = standardCount > 0;
                        const selected = isSelected(material);
                        const materialCode = material.material_code || material.id;

                        return (
                            <div
                                key={material.id}
                                role="button"
                                tabIndex={canSelect ? 0 : -1}
                                aria-disabled={!canSelect}
                                onClick={() => {
                                    if (canSelect) {
                                        handleOnclickItem(material, !selected);
                                    }
                                }}
                                onKeyDown={(event) => {
                                    if (canSelect && (event.key === "Enter" || event.key === " ")) {
                                        event.preventDefault();
                                        handleOnclickItem(material, !selected);
                                    }
                                }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 16,
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #edf0f2",
                                    backgroundColor: selected ? "#e1f2fc" : "#fff",
                                    color: canSelect ? "#0d0c0c" : "#9aa1a7",
                                    cursor: canSelect ? "pointer" : "not-allowed",
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                                        {materialCode} · {material.name}
                                    </div>
                                    {canSelect ? (
                                        <div style={{ marginTop: 4, fontSize: 12, color: "#6b7280" }}>
                                            Định mức: {standardCount} vật tư nguồn
                                        </div>
                                    ) : (
                                        <div style={{ marginTop: 4, fontSize: 12, color: "#d65a31" }}>
                                            Chưa có định mức gia công, chưa chọn được
                                        </div>
                                    )}
                                </div>

                                {!canSelect && (
                                    <a
                                        href={`/materials/${material.id}/?tab=outsource-standard`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(event) => event.stopPropagation()}
                                        style={{ color: "#1677d2", fontSize: 14, fontWeight: 600, whiteSpace: "nowrap" }}
                                    >
                                        Khai báo định mức
                                    </a>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default OutsourceMaterialSearchBar;
